import { createSlice, PayloadAction } from '@reduxjs/toolkit'

declare global {
  interface Window {
    process?: {
      env?: {
        REACT_APP_USE_STORED_STATE?: string
      }
    }
  }
}

window.process = {
  ...window.process,
}

export interface LayoutState {
  route?: string
  tab?: any
  data?: {
    departmentId?: string
  }
  [key: string]: any
}

let storedState: LayoutState | undefined
if (import.meta.env.VITE_USE_STORED_STATE) {
  try {
    const fullState = window.localStorage.getItem('_state')
    if (fullState) {
      storedState = JSON.parse(fullState).layout
    }
  } catch (e) {
    console.error('Unable to set initial state from local storage:', e)
  }
}

const initialState: LayoutState = storedState || {}

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setHome: (state, action: PayloadAction<any>) => {
      // Handle both old and new API formats
      if (typeof action.payload === 'string') {
        // Old format: just a route string
        state.route = action.payload
      } else if (action.payload) {
        // New format: object with route and/or data
        if (action.payload.route !== undefined) {
          state.route = action.payload.route
        }
        if (action.payload.data !== undefined) {
          state.data = action.payload.data
        }
        if (action.payload.tab !== undefined) {
          state.tab = action.payload.tab
        }
      }
    },
    setDepartment: (state, action: PayloadAction<string>) => {
      state.data = {
        departmentId: action.payload,
      }
    },
  },
})

export const { setHome, setDepartment } = layoutSlice.actions
export default layoutSlice.reducer